'use client';
import React from 'react';
import sitemap from '@images/ico_sitemap.webp';
import sitemapHovered from '@images/ico_sitemap_hover.webp';
import Image from 'next/image';
import { cn } from '@lib/utils';
import { useFullMenu } from '../full-menu/use-full-menu';

function FullMenuOpener(
  props: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >,
) {
  const { toggle } = useFullMenu();
  return (
    <button
      {...props}
      onClick={() => {
        toggle();
      }}
      className={cn('group flex items-center', props?.className)}
    >
      <Image
        className="block group-hover:hidden"
        src={sitemap}
        width={25}
        height={20}
        alt={'sitemap'}
      />
      <Image
        className="hidden group-hover:block"
        src={sitemapHovered}
        width={25}
        height={20}
        alt={'sitemap'}
      />
    </button>
  );
}

export default FullMenuOpener;
